import type { Gender } from '@xing-com/crate-common-graphql-types';
import type { SuperEllipseProps } from '@xing-com/super-ellipse';

export const genderMap = (
  gender?: Gender | null
): SuperEllipseProps['type'] => {
  switch (gender) {
    case 'FEMALE':
      return 'female-user';
    case 'MALE':
      return 'male-user';
    default:
      return 'neutral-user';
  }
};
